export class ImportModel {
  excelBase64?: string | undefined;
  companyId?: number;
}
